import Repository from "./Repository";

const CREATE_FEATURE = "add";
const GET_FEATURE = "get";
const UPDATE_FEATURE = "update";
const DELETE_FEATURE = "delete";
const ADD_CATEGORY = "addCategory";
const GET_CATEGORY = "getCategory";

export default {
  createFeature(payload) {
    return Repository.post(transformRoute(CREATE_FEATURE), payload);
  },
  getAllFeature(payload) {
    return Repository.post(transformRoute(GET_FEATURE), payload);
  },
  updateFeature(payload) {
    return Repository.post(transformRoute(UPDATE_FEATURE), payload);
  },
  deleteFeature(payload) {
    return Repository.post(transformRoute(DELETE_FEATURE), payload);
  },
  addCategory(payload) {
    return Repository.post(transformRoute(ADD_CATEGORY), payload);
  },
  getCategory(payload) {
    return Repository.post(transformRoute(GET_CATEGORY), payload);
  },
};

const transformRoute = (route) => {
  return `/features/${route}`;
};
